export default __webpack_public_path__ + "static/media/Foglie-sx.e881ed68.png";